import { bus, helper } from '@/utils'
import { getOperators, getPutData } from './helper'

export default {
  beforeDestroy () {
    bus.$off('show-edit-notification')
  },
  computed: {
    hasConditionsError () {
      return this.errors.has('key') || this.errors.has('operator') || this.errors.has('target')
    },
    isStatusRule () {
      return this.data.ruleType === 'states'
    },
    ruleTypes () {
      return [
        {
          key: 'states',
          label: this.$t('notificationsCreateRuleTypesOptionStates'),
          value: 'states'
        }
      ]
    }
  },
  methods: {
    closePopup () {
      this.reset()
      this.showModal = false
    },
    reset () {
      this.data = {
        conditions: {
          key: null,
          op: null,
          target: null
        },
        familyNames: [],
        id: null,
        message: null,
        ruleType: 'states',
        title: null
      }
      this.loading = false
      this.gettingNotification = false
      this.$nextTick(() => {
        this.$validator.reset()
        this.$validator.errors.clear()
      })
    },
    editNotification () {
      return this.$validator.validateAll()
        .then(async (result) => {
          if (result) {
            this.loading = true

            const rawData = Object.assign(this.data, { familyMembers: this.familyMembers })
            try {
              const data = getPutData(rawData, this.uid)
              const save = await this.$api.updateNotification(data)
              if (save.status !== 204) {
                return
              }

              this.$message({
                message: this.$t('messageNotificationUpdate'),
                showClose: true,
                type: 'success'
              })
            } catch (error) {
              const hasOwnerId = error.bodyText.match(/\\"ownerId\\"/g)
              const failedMsg = this.$t('NotificationsCreateFailedMessage')
              const noOwnerIdMsg = this.$t('NotificationsEditFailedNoOwnerIdMessage')
              const message = hasOwnerId ? noOwnerIdMsg : failedMsg

              helper.showErrorMessage(this, this.component, error, message)

              this.loading = false
              return
            }

            bus.$emit('get-notifications-list')
            this.closePopup()
          }
        })
    },
    getNotificationById (id) {
      return this.$api.getNotification(id)
        .then((notification) => {
          this.setDefaultNotification(notification)
          this.gettingNotification = false
        })
        .catch((error) => {
          helper.showErrorMessage(this, this.component, error)
          this.gettingNotification = false
          this.closePopup()
        })
    },
    setDefaultNotification (notification) {
      const { actions, event, familyName, id } = notification

      // Back-end promise that it will only return an array with one key now.
      const newActions = actions[0]
      const newConditions = event.conditions[0]

      this.data = {
        conditions: {
          key: newConditions.key,
          op: newConditions.op,
          target: newConditions.target
        },
        familyNames: familyName,
        id,
        message: newActions.body,
        ruleType: event.resource,
        title: newActions.title
      }
    }
  },
  name: 'NotificationsEdit',
  props: {
    familyMembers: {
      required: true,
      type: Object
    },
    familyNames: {
      required: true,
      type: Array
    },
    uid: {
      default: null,
      type: Number
    }
  },
  data () {
    return {
      component: 'notificationsEdit',
      data: {
        conditions: {
          key: null,
          op: null,
          target: null
        },
        familyNames: [],
        id: null,
        message: null,
        ruleType: null,
        title: null
      },
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      gettingNotification: false,
      operators: [],
      rules: {},
      labelWidth: '150px',
      loading: false,
      notification: [],
      showModal: false,
      titleAdd: 'Edit Notification Rule',
      validate: {
        deviceKey: /^H([0-9A-F]){2}$/
      }
    }
  },
  mounted () {
    this.operators = getOperators()

    bus.$on('show-edit-notification', ({ show, id }) => {
      if (show) {
        this.showModal = true
      }

      if (id) {
        this.gettingNotification = true
        this.getNotificationById(id)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/NotificationsEdit/NotificationsEdit.js